export interface BroadSignCreationAcceptanceModel {
  id: string
  agglomeration: string | null
  city: string | null
  building: string
  acceptanceStatus: string
  rejectionDetails: string | null
  // whether the creation is assigned to the gallery, the flag the tables are split on
  used: boolean
}

// the payload of the assignment, one entry per gallery whose flag is being flipped
export interface BroadSignCreationBuildingUsage {
  id: string
  used: boolean
}

// the statuses a gallery carries before it answers, kept out of the answers below so none of them
// gets a decision to show. sending is the short while between the send and the gallery taking it
export const BROADSIGN_ACCEPTANCE_NOT_SENT = 'not_sent'
export const BROADSIGN_ACCEPTANCE_SENDING = 'sending'

// the answers a gallery can give, every other status is an acceptance still on its way
export enum BroadSignAcceptanceStatus {
  ACCEPTED = 'accepted',
  PENDING = 'pending_acceptation',
  REJECTED = 'rejected',
}
